/* eslint-disable */
import React, {useEffect, useState} from "react";
import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import {
    BookOpen,
    FileText,
    Scale,
    Users,
    Settings,
    RefreshCcw,
    ClipboardCheck,
    Layers,
    Upload,
    FileCheck,
    Wrench,
    IndianRupee,
    Truck,
    NotebookText
} from "lucide-react";
import axios from 'axios';
import { setPageName } from "../../redux/features/PageName/PageName";
import config from "../../config/config";
import "./BusinessStructure.css";
import GrpPic from "./HomePageImages/Image/user.png";
import { useRoleAccess } from "./roleAccess";


const routeMap = {
    "R2R": "/Record-To-Report",
    // "H2R": "/delivery/h2r",
    "P2P": "/Procure-To-Pay",
    "O2C": "/Order-To-Cash",
    // "Vendor GL Ageing":"/GL-Reconciliation",
    "Vendor GL Ageing":"/Procure-To-Pay/Account-Payable/GL-Reconciliation",

    "Direct Tax": "/Direct-Tax",
    "Indirect Tax": "/Indirect-Tax",
    "Legal": "/Legal-Page",

    "Finance": "/Finance-Page",
    "Quality": "/Quality",
    "Transition": "/Transition-Page",
    "Transformation": "/Process-Excellence",

    "File Upload": "/File-Upload-Page",
    "File Approve": "/File-Upload-Check-Page",
    "Template Approve": "/Template-Upload-Approve-Page",
    "Upload Logs": "/File-Upload-Page",
};

const externalRoutes = {
    "H2R": "https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi",
    "Talent": "https://app.powerbi.com/Redirect?action=OpenApp&appId=8b17069c-8752-499e-bd1c-565836b83695&ctid=a3fb180d-23c4-44c9-a241-c78109202bd3&experience=power-bi",
    // "Import Logistics":"https://pfirstv2.tmindia.tatamotors.com/",
    "Import Logistics":"https://pfirstv2.inservices.tatamotors.com/",
};

// const Card = ({ icon: Icon, title, count }) => {
//     const history = useHistory();
//     const handleClick = () => {
//         const path = routeMap[title];

//         if (externalRoutes[title]) {
//             window.open(externalRoutes[title], "_blank");
//             return;
//         }

//         if (path) {
//             history.push(path);
//         } else {
//             console.warn("No route defined for:", title);
//         }
//     };
//     return (
//         <div className="tile-box" onClick={handleClick}>
//             {count > 0 && (
//                 <div className="tile-badge flashing">
//                     {count}
//                 </div>
//             )}
//             <Icon size={30} className="tile-icon" />
//             <p className="tile-text">{title}</p>
//         </div>
//     );
// };

const Card = ({ icon: Icon, title, count, index }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const handleClick = () => {
        const path = routeMap[title];
        dispatch(setPageName(`${title} Dashboard`));
        if (externalRoutes[title]) {
            window.open(externalRoutes[title], "_blank");
            return;
        }
        if (path) {
            history.push(path);
        } else {
            console.warn("No route defined for:", title);
        }
    };
    return (
        <div
            className="tile-box animate-card"
            style={{ animationDelay: `${index * 0.1}s` }}
            onClick={handleClick}
        >
            {count > 0 && (
                <div className="tile-badge flashing">
                    {count}
                </div>
            )}
            <Icon size={30} className="tile-icon" />
            <p className="tile-text">{title}</p>
        </div>
    );
};

const { API_BASE_URL } = config;

export default function BusinessStructure() {
    const dispatch = useDispatch();
    const { hasCategory, hasSubCategory, entity } = useRoleAccess();
    const [fileApproveCount, setFileApproveCount] = useState(0);
    const fetchFileApproveCount = async () => {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/file-approver-count`,
                {
                    user_id: localStorage.getItem("preferred_username"),
                },
                {
                    headers: {
                        Authorization: 'Basic YWRtaW4xOjEyMw==',
                        // Authorization: `Bearer ${token}`,
                    },
                }
            );
            setFileApproveCount(response.data.totalCount);
        } catch (error) {
            console.error('Error fetching file approve count:', error);
        }
    };

    useEffect(() => {
        fetchFileApproveCount();
        dispatch(setPageName(`Home`));
    }, []);

    return (
        <div className="business-wrapper">
            <div className="dashboard-header">
                <div>
                    {/* <h1 className="welcome-text">Welcome back {localStorage.getItem("name")}</h1> */}
                    {/* <h2 className="welcome-text">Welcome back {localStorage.getItem("name").split('[')[0].trim()}</h2> */}
                    <h2 className="welcome-text">Welcome back {localStorage.getItem("name").split('[')[0].trim().toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h2>
                    <p className="sub-text">Here's what you can manage today.</p>
                </div>
                <div className="user-info">
                    <img src={GrpPic} alt="User" className="user-avatar" />
                    <div>
                        <p className="user-name">{localStorage.getItem("preferred_username")}</p>
                        <span className="user-role">{entity}</span>
                    </div>
                </div>
            </div>
            <div className="layout-grid">
                {hasCategory("Delivery") && (
                    <div className="section-column">
                        <h2 className="section-title-new delivery">Delivery</h2>
                        <div className="tiles-wrapper">
                            {hasSubCategory("R2R") && (
                                <Card icon={FileText} title="R2R" index={0}/>
                            )}
                            {hasSubCategory("H2R") && (
                                <Card icon={Users} title="H2R" index={1}/>
                            )}
                            {hasSubCategory("P2P") && (
                                <Card icon={ClipboardCheck} title="P2P" index={2}/>
                            )}
                            {hasSubCategory("O2C") && (
                                <Card icon={Layers} title="O2C" index={3}/>
                            )}
                            {hasSubCategory("Vendor GL Ageing") && (
                                <Card icon={NotebookText} title="Vendor GL Ageing" index={4}/>
                            )}
                            {hasSubCategory("Import Logistics") && (
                                <Card icon={Truck} title="Import Logistics" index={5}/>
                            )}
                        </div>
                    </div>
                )}
                {hasCategory("Knowledge") && (
                    <div className="section-column">
                        <h2 className="section-title-new knowledge">Knowledge</h2>
                        <div className="tiles-wrapper">
                            {hasSubCategory("Direct Tax") && (
                                <Card icon={BookOpen} title="Direct Tax" index={0} />
                            )}
                            {hasSubCategory("Indirect Tax") && (
                                <Card icon={BookOpen} title="Indirect Tax" index={1} />
                            )}
                            {hasSubCategory("Legal") && (
                                <Card icon={Scale} title="Legal" index={2} />
                            )}
                        </div>
                    </div>
                )}
                {hasCategory("Enabling") && (
                    <div className="section-column">
                        <h2 className="section-title-new enabling">Enabling</h2>
                        <div className="tiles-wrapper">
                            {hasSubCategory("Talent") && (
                                <Card icon={Users} title="Talent" index={0}/>
                            )}
                            {hasSubCategory("Finance") && (
                                <Card icon={IndianRupee} title="Finance" index={1}/>
                            )}
                            {hasSubCategory("Quality") && (
                                <Card icon={Settings} title="Quality" index={2}/>
                            )}
                            {hasSubCategory("Transition") && (
                                <Card icon={RefreshCcw} title="Transition" index={3}/>
                            )}
                            {hasSubCategory("Transformation") && (
                                <Card icon={Wrench} title="Transformation" index={4}/>
                            )}
                        </div>
                    </div>
                )}
                {hasCategory("File Upload") && (
                    <div className="section-column">
                        <h2 className="section-title-new fileupload">File Upload</h2>
                        <div className="tiles-wrapper">
                            {hasSubCategory("Process Upload User") && (
                                <Card icon={Upload} title="File Upload" index={0}/>
                            )}
                            {hasSubCategory("Process Upload Approver") && (
                                <Card icon={FileCheck} title="File Approve" count={fileApproveCount} index={1}/>
                            )}
                            {hasSubCategory("Template Upload Approver") && (
                                <Card icon={ClipboardCheck} title="Template Approve" index={2}/>
                            )}
                            {hasSubCategory("Template Upload Approver") && (
                                <Card icon={ClipboardCheck} title="Upload Logs" index={3}/>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}